import {TokenizedFilterInput} from '../../../components/filter-bar/tokenized-filter-input'

type InsightsFilterProps = {
  filterValue: string
  // The number of project items matching the filterValue
  filterCount?: number | undefined
  handleNewFilterBarValueChange: (value: string) => void
  onSaveChanges?: (() => void) | undefined
  onResetChanges?: (() => void) | undefined
  inputRef: React.RefObject<HTMLInputElement | null> | undefined
  hideSaveButton?: boolean
}

export const InsightsFilters = ({
  filterCount,
  filterValue,
  handleNewFilterBarValueChange,
  onSaveChanges,
  onResetChanges,
  inputRef,
  hideSaveButton,
}: InsightsFilterProps) => {
  return (
    <TokenizedFilterInput
      inputRef={inputRef}
      value={filterValue}
      onChangeValue={handleNewFilterBarValueChange}
      filterCount={filterCount}
      onSaveChanges={onSaveChanges}
      onResetChanges={onResetChanges}
      hideSaveButton={hideSaveButton}
      hideSplitSaveButton
      hideDisplayButton
    />
  )
}

try{ InsightsFilters.displayName ||= 'InsightsFilters' } catch {}